import script from "./ChatModel.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatModel.vue?vue&type=script&setup=true&lang=js"

import "./ChatModel.vue?vue&type=style&index=0&id=521c86d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521c86d9"]])

export default __exports__